import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatBytes } from '../../../../Helpers/Chat/ChatHelper';

export default class PreviewDocument extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.updateMedia(this.props.media, {
            msgType: 'file',
        });
    }

    render() {
        const { media: { name = '', size = '' } = {}, placeholder } = this.props;
        const updateSize = formatBytes(size);

        return (
            <div className="type-image document">
                <div className="type-thumb-image">
                    <img src={placeholder} alt="" />
                    <p>{`${name} , ${updateSize}`}</p>
                </div>
            </div>
        );
    }
}

PreviewDocument.propTypes = {
    updateMedia: PropTypes.func.isRequired,
    media: PropTypes.shape({
        name: PropTypes.string,
        size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    placeholder: PropTypes.string,
};
